import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { GoChevronLeft } from "react-icons/go";
import { useAuthContext } from "../../contexts/AuthContext";

function SidebarMainNavbar() {
  const { menuState, setMenuState } = useAuthContext();

  const toggle_class = menuState ? "sidebar-open" : "sidebar-close";

  return (
    <div className="main-navbar">
      <div
        className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0 navbar navbar-light"
        type="light"
      >
        <div className="w-100 mr-0" style={{ lineHeight: "25px" }}>
          <div className="d-table m-auto">
            <Link to="dashboard">
              <img
                id="main-logo"
                className="d-inline-block align-top mr-1"
                style={{ maxWidth: "140px" }}
                src={require("../../images/logo.png")}
                alt="IQVIA Unstructured Data"
              />
            </Link>
            {/* {!hideLogoText && <div className="d-none d-md-inline ml-1">Unstructured Data</div>} */}
          </div>
        </div>
        <a
          className={`toggle-sidebar ${toggle_class}`}
          onClick={() => setMenuState(!menuState)}
        >
          <GoChevronLeft />
        </a>
      </div>
    </div>
  );
}

export default SidebarMainNavbar;
